// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__6DE+4","subtitle":"styles_subtitle__8Z7mR"};